// index.js
import React from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import { GoogleOAuthProvider } from "@react-oauth/google";
import { NetworkStatusProvider } from "./components/layout/NetworkStatusProvider";

import store from "./store";
import App from "./App";
import reportWebVitals from "./reportWebVitals";

import "./tailwind.css";
import "./index.css";

const GOOGLE_CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID;
const FACEBOOK_APP_ID = process.env.REACT_APP_FACEBOOK_APP_ID;

// Initialize Facebook SDK
function initializeFacebookSDK() {
  // Load the Facebook SDK script
  (function (d, s, id) {
    const fjs = d.getElementsByTagName(s)[0];
    if (d.getElementById(id)) return;
    const js = d.createElement(s);
    js.id = id;
    js.src = "https://connect.facebook.net/en_US/sdk.js";
    fjs.parentNode.insertBefore(js, fjs);
  })(document, "script", "facebook-jssdk");

  // Initialize Facebook SDK after it's loaded
  window.fbAsyncInit = function () {
    window.FB.init({
      appId: FACEBOOK_APP_ID,
      cookie: true,
      xfbml: true,
      version: "v16.0",
    });
    console.log("Facebook SDK Initialized");
  };
}

// Call the function to initialize the Facebook SDK
initializeFacebookSDK();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>
      <Provider store={store}>
        <NetworkStatusProvider>
          <App />
        </NetworkStatusProvider>
      </Provider>
    </GoogleOAuthProvider>
  </React.StrictMode>,
);

reportWebVitals();

// // index.js
// import React from "react";
// import ReactDOM from "react-dom/client";
// import { Provider } from "react-redux";
// import { GoogleOAuthProvider } from "@react-oauth/google";

// import store from "./store";
// import App from "./App";
// import reportWebVitals from "./reportWebVitals";

// import "./tailwind.css";
// import "./index.css";

// const GOOGLE_CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID;

// const root = ReactDOM.createRoot(document.getElementById("root"));
// root.render(
//   <React.StrictMode>
//     <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>
//       <Provider store={store}>
//         <App />
//       </Provider>
//     </GoogleOAuthProvider>
//   </React.StrictMode>,
// );

// reportWebVitals();
// // ================================================================
// // // index.js
// // import React from "react";
// // import ReactDOM from "react-dom/client";

// // import "./tailwind.css";
// // import "./index.css";

// // import { Provider } from "react-redux";
// // import store from "./store";
// // import App from "./App";
// // import reportWebVitals from "./reportWebVitals";

// // const root = ReactDOM.createRoot(document.getElementById("root"));
// // root.render(
// //   <React.StrictMode>
// //     <Provider store={store}>
// //       <App />
// //     </Provider>
// //   </React.StrictMode>,
// // );

// // reportWebVitals();
